<template>
  <el-dialog
    class="formula-dlg dialog-common"
    title="公式编辑"
    :visible.sync="show"
    width="900px"
    @close="onClose"
  >
    <div class="content">
      <div class="kf-editor-wrap" ref="editorWrap" style="visibility: hidden"></div>
      <div class="kf-loading" ref="loading">加载中...</div>
    </div>
    <div slot="footer">
      <el-button @click="show = false" size="medium" style="width: 88px"> 取消 </el-button>
      <el-button type="primary" @click="onOk" size="medium" style="width: 88px"> 确定 </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'FormulaDlg',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      editor: null,
    };
  },
  watch: {
    visible(val) {
      this.show = val;
      if (val && !this.editor) {
        this.$nextTick(() => {
          this.createEditor();
        });
      }
    },
    show(val) {
      this.$emit('update:visible', val);
    },
  },
  created() {},
  mounted() {},
  methods: {
    // on event
    onOk() {
      if (!this.editor) return;
      // 获取 latex 表达式
      const source = this.editor.execCommand('get.source');
      // console.log(source);
      if (source.trim() == '\\placeholder') {
        this.$warning('请输入公式');
        return;
      }
      this.editor.execCommand('get.image.data', (imgData) => {
        this.$emit('on-formula-img', imgData.img);
        this.show = false;
      });
    },
    onClose() {
      if (!this.editor) return;
      // 清楚编辑器内容
      this.editor.requestService('control.select.all');
      this.editor.requestService('control.delete.string');
    },
    // other
    createEditor() {
      let factory = window.kf.EditorFactory.create(window.$(this.$refs.editorWrap)[0], {
        render: {
          fontsize: 18,
        },
        ui: {
          device: 'pc',
          scale: 1,
          protocol: 'documentEvent',
        },
        resource: {
          path: window.location.origin + '/js/formula/resource/',
        },
      });

      factory.ready((KFEditor) => {
        // console.log(KFEditor);
        // this指向KFEditor
        KFEditor.execCommand('render', '\\placeholder');
        KFEditor.execCommand('focus');
        KFEditor.execCommand('ready');

        this.$refs.editorWrap.style.visibility = 'visible';
        this.$refs.loading.style.display = 'none';
        // window.kfe = KFEditor;
        this.editor = KFEditor;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  position: relative;
}
.kf-loading {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.kf-editor-wrap {
  height: 540px !important;
  ::v-deep {
    .kf-editor-edit-area {
      height: 120px;
    }
    .kf-editor-header {
      display: none;
    }
    .kf-editor-ui-keyboard {
      // height: 350px;
      border-bottom: 1px solid #e4e4e4;
      .kf-editor-ui-keyboard-menu,
      .kf-editor-ui-keyboard-panel,
      .kf-editor-ui-keyboard-page {
        height: 410px;
      }
    }
    .kf-editor-ui-keyboard-footer {
      display: none;
    }
    .kf-editor-ui-keyboard-menu-list-item-active {
      background-color: $primary-color !important;
    }
  }
}
</style>
